// const BaseURL = 'https://taskbackend-qh6a.onrender.com/api/';
// const BaseURL = 'http://52.90.237.251:4000/api/';
// const BaseURL = 'http://localhost:4000/api/';
// const BaseURL = 'https://api.rachkitt.store/api/';
const BaseURL = 'https://api.wisetechshop.com/api/';
const Endpiont = {
    auth: {
        login: 'user/login',
        register: 'user/register',
        forgot: 'user/forgot'
    },
    product: {
        add: 'product/add',
        list: 'product',
        delete: 'product/delete/',
        update: 'product/update/'
    },
    category: {
        add: 'category/add',
        list: 'category',
        delete: 'category/delete/',
        update: 'category/update/'
    },
    subCategory: {
        add: 'sub-category/add',
        list: 'sub-category',
        delete: 'sub-category/delete/',
        update: 'sub-category/update/'
    },
    brand: {
        add: 'brand/add',
        list: 'brand',
        delete: 'brand/delete/',
        update: 'brand/update/'
    },
    competibleBrand: {
        add: 'compatiable/brand/add',
        list: 'compatiable/brand',
        delete: 'compatiable/brand/delete/',
        update: 'compatiable/brand/update/'
    },
    color: {
        add: 'color/add',
        list: '/color',
        delete: '/color/delete/',
        update: 'color/update/'
    },
    warehouse: {
        add: 'warehouse/add',
        list: '/warehouse',
        delete: '/warehouse/delete/',
        update: 'warehouse/update/',
        mapLocation: 'warehouse/map-location'
    },
    roughListing: {
        add: 'rough-listing/add',
        list: 'rough-listing',
        delete: 'rough-listing/delete/',
        assignSku: 'rough-listing/assign-sku',
        update: 'rough-listing/update/',
        createTasks: 'rough-listing/create-tasks/',
        checkVariant: 'rough-listing/check-variant'
    },
    po: {
        add: 'po/add',
        list: 'po',
        nonInventoryList: 'po/non-inventory'
    },
    so: {
        add: 'sale-order/add',
        list: 'sale-order'
    },
    inventory: {
        add: 'inventory/add',
        list: 'inventory',
        inventoryProduct: 'inventory/product',
        updateInventoryProduct: 'inventory/product/update',
        getSkuByWarehouse: 'inventory/sku-list',
        internalTransfer: 'inventory/internal-transfer'
    },
    returnOrder: {
        add: 'return/add',
        list: 'return'
    },
    task: {
        list: '/task',
        update: 'task/update/',
        submit: 'task/submit/',
        assignOrUnassignTask: 'task/assign'
    },
    role: {
        list: 'role/',
        update: 'role/update/'
    },
    getUsers: {
        list: 'user'
    },
    deleteUser: {
        deletUse: "user/delete/"
    },
    media: {
        upload: 'media/assets',
        delete: 'media/assets/'
    },
    general: {
        categoryAgainstBrand: 'general/category-by-brand/'
    },
    shopify: {
        locations: 'shopify/locations',
        sync: 'shopify/sync',
        products: 'public/products'
    },
    webhooks: {
        notifications: 'webhooks/notifications',
        markRead: 'webhooks/notifications/read'
    },
    liveStatus: {
        add: 'live-status/add',
        list: 'live-status',
        delete: 'live-status/delete/'
    },
    matchProduct: {
        add: 'match-product/add',
        list: 'match-product',
        update: 'match-product/update/',
        delete: 'match-product/delete/',
        bulkAdd: 'match-product/bulk-add'
    },
    qrCode: {
        add: 'qr/add',
        list: 'qr',
        get: 'qr/',
        update: 'qr/update/',
        delete: 'qr/delete/'
    }
};

export { BaseURL, Endpiont };
